import { useTheme } from "@mui/material";
import * as React from "react";

interface IProps {
    height?: number | string;
    color?: MprcColors;
}

export const MprcHr: React.FC<IProps> = (props) => {
    const { height = 5, color = "chip" } = props;
    const theme = useTheme();
    return (
        <hr style={{ height: height!, backgroundColor: theme.palette[color!].main, borderStyle: "none" }} />
    );
};
